module.exports = __webpack_public_path__ + "images/emoji/cookie.4a565d9e39ffa95d6c2a.png";